export interface OrderHistory {
  id: string;
  status: string;
  orderNumber: string;
  orderDate: string;
  comments: string | null;
  fileBasePath: string | null;
  orderData: string;
  totalQuantity: number;
  type: string;
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    mrn: string | null;
  } | null;
}

export enum OrderTypes {
  ALL = 0,
  WEBSHOP = 1,
  PATIENT = 2
}

